import { Component, HostListener, inject, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '@core/service/auth.service';
import { environment } from '@env/environment';
import { StaffserviceService } from '@core/service/staff/staffservice.service';
import { Observable, Subject } from 'rxjs';
import { storeUserIdPhyIdState } from './authentication/Store/auth.state';
import { Store } from '@ngxs/store';
import { takeUntil } from 'rxjs/operators';
import { LocalDataSourceService } from '@core/service/local-data-source.service';
import { GlobalRouterService } from '@core/http/global-router/global-router.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { NgSelectConfig } from '@ng-select/ng-select';
import { AuditLogService } from '@core/service/audit-log.service';
import { HttpResponse } from '@angular/common/http';
import { HubConnection } from '@microsoft/signalr';
import { SessionTimeoutService } from '@core/service/session-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatCardModule,
    MatButtonModule,
  ]
})
export class AppComponent implements OnDestroy {
  private _sessionTimeoutService = inject(SessionTimeoutService);

    private auditService=inject(AuditLogService)  
    private authService=inject(AuthService)
   private _hubConnection: HubConnection | undefined;
     private router=inject(Router)
    
  
   
    onDestroy$ = new Subject();
    _store=inject(Store)
   userIdPhyId$: Observable<any>=this._store.select(storeUserIdPhyIdState.getUserIdPhyId);
  locationId: number;
  userId: number;
  
    constructor(
      private _staffserviceService : StaffserviceService,
      private localDataService:LocalDataSourceService,
      private _globalRouterService: GlobalRouterService,
      private config: NgSelectConfig 
      ) {
     this._globalRouterService; // don't delete this line (used for global-router).
     this.config.notFoundText = 'Record not found';
   //  this.config.appendTo = 'body';    
    // this.config.bindValue = 'value';
    }
  ngOnDestroy(): void {
     
  }
  ngOnInit() : void{
    this.userIdPhyId$.pipe(takeUntil(this.onDestroy$)).subscribe(res => {
      if (res) {
      this.locationId = res?.locationId;
      this.userId = +res?.userId;
      this.getLogOutTime(this.userId,this.locationId)
      }
    });
    
      this.localDataService.timeOutSettings$.pipe(takeUntil(this.onDestroy$)).subscribe(res=>{
        if(res){
          this.getLogOutTime(this.userId,this.locationId);
        }
      })
  }

    logOutApplication():void{
      this.auditService.activityLogOut(this.userId).pipe(takeUntil(this.onDestroy$)).subscribe((res) => {

        this._hubConnection?.stop().then((res1)=> {
 
        }); 
         this.authService.logout();
        this.router.navigate(["/authentication/signin"]);
 
       // }
      },error=>{
         this.authService.logout();
        this.router.navigate(["/authentication/signin"]);
      })
    }
    saveAuditlogData(){
      let activityId: number = 10 // For Accessed Type.
      let description: string = 'LogOut';
      let moduleName: string = 'Authentication';
      this.saveAuditLog(activityId, description, moduleName);
    }
    saveAuditLog(activityId: number, description: string, moduleName: string){
      this.saveAuditLogObs(activityId, description, moduleName).pipe(takeUntil(this.onDestroy$)).subscribe({
        next: (res) => {
          this.logOutApplication()
        }, error: (err) => {
        }
      });
    }
    private _auditLogService = inject(AuditLogService);
    saveAuditLogObs(activityId: number, description: string, moduleName: string): Observable<HttpResponse<any>> {
      return this._auditLogService.saveAudit(activityId, description, moduleName,'','');
    }
    logOutTime:number;
    getLogOutTime(userId,locationId) {
      if(locationId && userId){
      this._staffserviceService.getLogoutSettingsTime(userId,locationId).pipe(takeUntil(this.onDestroy$)).subscribe(res=>{
        if(res.status === 200){
          const logOutData = res.body[0] || {};
          const {
            logoutTime = environment.idle_time
          } = logOutData;
          this.localDataService.getLogOutSettingsData(res.body[0])
          const isAlreadySessionExists = this._sessionTimeoutService.isAlreadySessionExists;
          if (isAlreadySessionExists) {
            this._sessionTimeoutService.stopWatching();
          }
          this._sessionTimeoutService.setLogoutTime = logoutTime;
          this._sessionTimeoutService.startWatching(logoutTime * 1000);
        }
      })
    }
    }
    @HostListener('window:unload', ['$event'])
    onUnload(event: Event): void {
      this.saveAuditlogData1();
    }
    saveAuditlogData1(){
      let activityId: number = 10 // For Accessed Type.
      let description: string = 'LogOut';
      let moduleName: string = 'Authentication';
      this.saveAuditLog(activityId, description, moduleName);
    }
    saveAuditLog1(activityId: number, description: string, moduleName: string){
      this._auditLogService.saveAudit1(activityId, description, moduleName,'','');
    }
    
}
